//@ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import { Me } from '@yandex-int/k-common/typings';
import { Button, H3, Text, Link, Modal, SimpleText, ModalCloseProps, BackgroundImage } from 'platform-components';
import { CloseButton } from 'platform-components/src/components/close-button/_view/close-button_view_outer';
import { getMe } from 'platform-components/src/components/user/selectors';
import { withRouterPath, InjectedProps as WithRouterPathHOC } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { connect } from 'react-redux';
import ym from 'react-yandex-metrika';
import { bindActionCreators, Dispatch } from 'redux';

import * as userActions from 'common.components/user/actions';
import { getTeamIdFromPath } from 'utils/path';

import { RootAction, ReduxTeacherStore } from '../../typings';

import { HAS_NOT_SEEN_NEW_SUBJECT_MODAL } from './typings';

import './new-subject-modal.scss';

interface DispatchProps {
    addViewedHint: (hintKey: string, hintValue: any) => void;
}

interface StateProps {
    currentTeamId: number | null;
    me: Me | null;
}

interface Props extends StateProps, DispatchProps, WithRouterPathHOC, WrappedComponentProps {}

// eslint-disable-next-line @typescript-eslint/ban-types
class NewSubjectModalComponent extends React.PureComponent<Props, {}> {
    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };
    context!: React.ContextType<React.Context<{ staticUrls: Record<string, string> }>>;

    handleModalSeen = (
        metrikaGoal: 'teacher_modal_force_add_subject_view' | 'teacher_modal_force_add_subject_close'
    ) => {
        const { addViewedHint, me } = this.props;

        ym('reachGoal', metrikaGoal, {
            subject: SUBJECTS_SLUGS.functionalLiteracy,
            user_id: me?.id,
        });

        addViewedHint(HAS_NOT_SEEN_NEW_SUBJECT_MODAL, false);
    };

    render() {
        const { getRouterPath, intl, currentTeamId } = this.props;
        const { staticUrls } = this.context;

        if (!currentTeamId) {
            return null;
        }

        const newSubjectUrl = getRouterPath(staticUrls.labLibrarySubject, {
            classId: currentTeamId,
            subject: SUBJECTS_SLUGS.functionalLiteracy,
        });

        return (
            <Modal
                //@ts-ignore - EDUCATION-37077: [react-update]: fixme typings: Хочет ReactNode вместo JSX.Element
                Close={(closeProps: ModalCloseProps) => (
                    <CloseButton {...closeProps} position={CloseButton.POSITION.ABSOLUTE} />
                )}
                hasClose
                mix="new-subject-modal"
                onRequestClose={() => this.handleModalSeen('teacher_modal_force_add_subject_close')}
                opened
                theme={Modal.THEMES.TEACHER}
            >
                <Modal.Img>
                    <BackgroundImage
                        mix="new-subject-modal__img"
                        objectFit="cover"
                        src={intl.formatMessage({ id: 'newSubjectModal.image' })}
                    />
                </Modal.Img>
                <Modal.Header>
                    <H3 id="newSubjectModal.title" weight={Text.WEIGHT.M} />
                </Modal.Header>
                <Modal.Content>
                    <div className="new-subject-modal__description">
                        <Text id="newSubjectModal.description" />
                    </div>
                </Modal.Content>
                <Modal.Footer>
                    <Link isRouter to={newSubjectUrl}>
                        <Button
                            className="new-subject-modal__button"
                            onClick={() => this.handleModalSeen('teacher_modal_force_add_subject_view')}
                        >
                            <SimpleText id="newSubjectModal.action" />
                        </Button>
                    </Link>
                </Modal.Footer>
            </Modal>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore): StateProps => ({
    currentTeamId: getTeamIdFromPath(),
    me: getMe(storeState),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>): DispatchProps => {
    return bindActionCreators(
        {
            addViewedHint: userActions.addViewedHint,
        },
        dispatch
    );
};

export const NewSubjectModal = withRouterPath(
    injectIntl(connect(mapStateToProps, mapDispatchToProps)(NewSubjectModalComponent))
);
